"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PublicOpinion = _interopRequireDefault(require("@rsuite/icon-font/lib/application/PublicOpinion"));

// Generated by script, don't edit it please.
var PublicOpinion = (0, _createSvgIcon["default"])({
  as: _PublicOpinion["default"],
  ariaLabel: 'public opinion',
  category: 'application',
  displayName: 'PublicOpinion'
});
var _default = PublicOpinion;
exports["default"] = _default;
module.exports = exports.default;